import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "@nuxtjs/composition-api";

import { useI18n } from "@/composables";
import { useCartsStore, useCheckoutStore } from "@/store";
import { filterRemoveUndefined } from "@/utils/transform/array";
import { toCurrency } from "@/utils/transform/text";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartsDrawerFooter',
  props: {
  cartId: {
    type: String,
    required: true,
  },
},
  emits: ["showLoadingOverlay", "checkout"],
  setup(__props, { emit }: { emit: ({
  (e: "showLoadingOverlay", show: boolean): void;
  (e: "checkout"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const i18n = useI18n();





const { cartId } = toRefs(props);

const cartsStore = useCartsStore();
const checkoutStore = useCheckoutStore();

const cart = computed(() => cartsStore.carts[cartId.value]);

const subtotal = computed(() => {
  if (!cart.value) {
    return;
  }

  return toCurrency(cart.value.subtotal, { locales: i18n.locale, currency: "USD" });
});

const cartItems = computed(() => {
  if (!cart.value) {
    return [];
  }
  return cart.value.cartItemIds.map((cartItemId) => cartsStore.cartItems[cartItemId]).filter(filterRemoveUndefined);
});

const unavailableCartItemsIds = computed(() => {
  return cartItems.value
    .filter((cartItem) => {
      const retailerProductVariant = cartsStore.retailerProductVariants[cartItem.retailerProductVariantId];
      return !retailerProductVariant?.availability;
    })
    .map((cartItem) => cartItem.id);
});

const hasUnavailableCartItems = computed(() => unavailableCartItemsIds.value.length > 0);

const onCheckout = async () => {
  emit("showLoadingOverlay", true);
  await checkoutStore.createCartCheckout({ cartId: cartId.value });
  emit("checkout");
  emit("showLoadingOverlay", false);
};

const onDeleteUnavailableCartItems = async () => {
  emit("showLoadingOverlay", true);
  await cartsStore.deleteCartItem({ ids: unavailableCartItemsIds.value });
  emit("showLoadingOverlay", false);
};

return { __sfc: true,i18n, emit, props, cartId, cartsStore, checkoutStore, cart, subtotal, cartItems, unavailableCartItemsIds, hasUnavailableCartItems, onCheckout, onDeleteUnavailableCartItems }
}

})